import { User } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Logo } from "./Logo";

const MiniChatIllustration = () => {
  const { t } = useLanguage();
  return (
        <div className="relative w-full mx-auto">
      {/* Chat Window */}
      <div className="bg-card rounded-lg shadow-lg border border-border p-4 space-y-3">
        {/* Header */}
        <div className="flex items-center gap-2 pb-3 border-b border-border">
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
            <Logo layout="icon-only" className="w-5 h-5" />
          </div>
          <div>
            <div className="text-sm font-semibold">{t.miniIllustrations.chat.header}</div>
            <div className="text-xs text-muted-foreground">{t.miniIllustrations.chat.status}</div>
          </div>
        </div>

        {/* Messages */}
        <div className="space-y-3">
          {/* User message */}
          <div className="flex justify-end animate-fade-in">
            <div className="bg-primary/10 rounded-lg px-3 py-2 max-w-[80%]">
              <p className="text-xs">{t.miniIllustrations.chat.userMessage}</p>
            </div>
          </div>

          {/* Bot message */}
          <div className="flex gap-2 animate-fade-in" style={{ animationDelay: "0.3s" }}>
            <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Logo layout="icon-only" className="w-4 h-4" />
            </div>
            <div className="bg-accent rounded-lg px-3 py-2 max-w-[80%]">
              <p className="text-xs">{t.miniIllustrations.chat.botResponse}</p>
            </div>
          </div>

          {/* User message */}
          <div className="flex justify-end animate-fade-in" style={{ animationDelay: "0.6s" }}>
            <div className="bg-primary/10 rounded-lg px-3 py-2 max-w-[80%]">
              <p className="text-xs">{t.miniIllustrations.chat.thanks}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniChatIllustration;
